import type { Plugin } from "../types/index.js";

export const agentNativePlugin: Plugin = {
  name: "agent-native",
};
